import {
  CaptionHeavy,
  DealCardDefaultSkeleton,
  MediaQuery,
} from '@pelando/components';
import styled from 'styled-components';
import EmptyState from '../../../components/EmptyState';

export const StoreDealsTabContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
  padding: 0 16px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    padding: 0;
  }
`;

export const DealStoreSeeMore = styled.button`
  ${CaptionHeavy}
  background: none;
  width: 100%;
  color: rgb(${({ theme }) => theme.colors.Alpha});
  display: flex;
  justify-content: center;
  align-items: center;
`;

export type SkeletonContainerProps = {
  animate?: boolean;
  cardsLength: number;
};

export const SkeletonContainer = styled.div<SkeletonContainerProps>`
  box-sizing: border-box;
`;

export const DealStoreCardSkeleton = styled(DealCardDefaultSkeleton)`
  margin-bottom: 8px;
`;

export const DealsEmptyState = styled(EmptyState)`
  margin-top: 48px;
  margin-bottom: 120px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    margin: 112px 0;
  }
`;
